import { __assign } from 'tslib';
import { getLuminance, darken, lighten } from '@mui/material';
import { convertColor } from '../providers/themeColors/utils.js';

var generateDisabledButtonSx = function (buttonStyle) {
    return __assign({}, ((buttonStyle === null || buttonStyle === void 0 ? void 0 : buttonStyle.borderRadius) && { borderRadius: buttonStyle === null || buttonStyle === void 0 ? void 0 : buttonStyle.borderRadius }));
};
var getConvertedColor = function (theme, colorToConvert) {
    return convertColor(theme, colorToConvert);
};
var generateButtonSx = function (_a) {
    var _b;
    var _c, _d, _e, _f, _g, _h;
    var buttonStyle = _a.buttonStyle, theme = _a.theme, _j = _a.styleName, styleName = _j === void 0 ? "&" : _j;
    var borderColor = getConvertedColor(theme, (_c = buttonStyle === null || buttonStyle === void 0 ? void 0 : buttonStyle.colors) === null || _c === void 0 ? void 0 : _c.borderColor);
    var color = getConvertedColor(theme, (_d = buttonStyle === null || buttonStyle === void 0 ? void 0 : buttonStyle.colors) === null || _d === void 0 ? void 0 : _d.textColor);
    var backgroundColor = getConvertedColor(theme, (_e = buttonStyle === null || buttonStyle === void 0 ? void 0 : buttonStyle.colors) === null || _e === void 0 ? void 0 : _e.backgroundColor);
    var backgroundColorHover = getConvertedColor(theme, (_f = buttonStyle === null || buttonStyle === void 0 ? void 0 : buttonStyle.hoverColors) === null || _f === void 0 ? void 0 : _f.backgroundColor);
    var borderColorHover = getConvertedColor(theme, (_g = buttonStyle === null || buttonStyle === void 0 ? void 0 : buttonStyle.hoverColors) === null || _g === void 0 ? void 0 : _g.borderColor);
    var colorHover = getConvertedColor(theme, (_h = buttonStyle === null || buttonStyle === void 0 ? void 0 : buttonStyle.hoverColors) === null || _h === void 0 ? void 0 : _h.textColor);
    return _b = {},
        _b[styleName] = __assign(__assign(__assign(__assign(__assign({}, ((buttonStyle === null || buttonStyle === void 0 ? void 0 : buttonStyle.borderRadius) && {
            borderRadius: buttonStyle === null || buttonStyle === void 0 ? void 0 : buttonStyle.borderRadius
        })), (backgroundColor && {
            backgroundColor: backgroundColor
        })), (color && { color: color })), (borderColor && {
            border: "1px solid ".concat(borderColor)
        })), { "&:hover": __assign(__assign(__assign({}, (backgroundColorHover && { backgroundColor: backgroundColorHover })), (colorHover && { color: colorHover })), (borderColorHover && {
                border: "1px solid ".concat(borderColorHover)
            })) }),
        _b;
};
var adaptHoverColor = function (color) {
    if (getLuminance(color) > 0.5) {
        // light color
        return darken(color, 0.05);
    }
    else {
        // dark color
        return lighten(color, 0.25);
    }
};

export { adaptHoverColor, generateButtonSx, generateDisabledButtonSx };
//# sourceMappingURL=buttonStyle.js.map
